export default "__VITE_ASSET__D3jjsh6P__"